<template>
  <div class="page-box">
    <div class="page-box-content" style="padding-bottom: 0">
      <div class="scoped-right">
        <Checkbox v-model="form.type" :true-value="1" :false-value="0">{{ $t('name.address.active_type') }}</Checkbox>
        <Checkbox v-model="create" style="margin: 0 20px">{{ form.id ? $t('name.address.active_update') : $t('name.address.active_create') }}</Checkbox>
        <Button @click="$refs.modal.open()">{{ $t('name.address.active_address') }}</Button>
        <Modal ref="modal" @click="onAddress" />
      </div>
      <div class="scoped-title">{{ title }}</div>
      <Form ref="form" :model="form" :rules="rule">
        <Row :gutter="20">
          <Col :span="6">
            <FormItem :label="$t('name.address.name')" prop="name">
              <Input v-model="form.name" />
            </FormItem>
          </Col>
          <Col :span="6">
            <FormItem :label="$t('name.address.contact')">
              <Input v-model="form.contact" />
            </FormItem>
          </Col>
          <Col :span="6">
            <FormItem :label="$t('name.address.phone')" prop="phone">
              <Input v-model="form.phone" />
            </FormItem>
          </Col>
          <Col :span="6">
            <FormItem :label="$t('name.address.email')">
              <Input v-model="form.email" />
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="20">
          <Col :span="6">
            <FormItem :label="$t('name.address.city')" prop="city">
              <Input v-model="form.city" />
            </FormItem>
          </Col>
          <Col :span="9">
            <FormItem :label="$t('name.address.address')" prop="address">
              <Input v-model="form.address" />
            </FormItem>
          </Col>
          <Col :span="3">
            <FormItem :label="$t('name.address.number')" prop="number">
              <Input v-model="form.number" />
            </FormItem>
          </Col>
          <Col :span="3">
            <FormItem :label="$t('name.address.zip')" prop="zip">
              <Input v-model="form.zip" />
            </FormItem>
          </Col>
          <Col :span="3">
            <FormItem :label="$t('name.address.house')">
              <Input v-model="form.house" />
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
  </div>
</template>
<script>
import Modal from './modal';
import { put } from '@/api/address';

export default {
  components: {
    Modal
  },
  props: {
    title: String
  },
  data() {
    return {
      create: true,
      form: {},
      rule: {
        name: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        address: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        number: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        zip: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        city: [
          { required: true, message: ' ', trigger: 'blur' }
        ]
      },
    }
  },
  methods: {
    put() {
      this.$refs.form.validate((valid) => {
        // 是否需要保存
        if (valid && this.create) {
          put(this.form).then(() => {
            // 保存地址成功，去掉保存地址
            this.create = false
          })
        }
      })
    },
    onAddress(address) {
      this.form = address
      this.create = false
    },
    // 获取地址
    async get() {
      return new Promise(resolve => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            return resolve(this.form)
          }
          resolve(false)
        })
      });
      
    }
  },
};
</script>
<style lang="less" scoped>
  @import '@/style/app.less';
  
  .scoped-title{
    color: @color-content;
    font-size: 16px;
    line-height: 30px;
    padding-bottom: 15px;
  }
  
  .scoped-right{
    float:right;
  }
</style>